<template>
  <el-checkbox-group class="SwitchButton" v-model="val" v-bind="$attrs">
    <el-checkbox-button
      v-for="option in options"
      :key="option.value"
      :label="option.value"
      >{{ option.label }}</el-checkbox-button
    >
  </el-checkbox-group>
</template>

<script>
import { CheckboxGroup, CheckboxButton } from 'element-ui'

/**
 * Switch entre plusieurs options avec possibilité d'annuler.
 */
export default {
  name: 'UbiSwitchButton',
  components: {
    ElCheckboxGroup: CheckboxGroup,
    ElCheckboxButton: CheckboxButton
  },
  props: {
    /**
     * Les options possibles, sous la forme d'un tableau d'objets `{value: ..., label: ...}`.
     */
    options: Array,
    /**
     * La valeur actuellement choisie
     * @model
     */
    value: String
  },
  computed: {
    val: {
      get () {
        return this.value !== null ? [this.value] : []
      },
      set (values) {
        const value = values.pop() || null
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
}
</script>

<docs>
### Exemple

```jsx
let value = 'y';
<ubi-switch-button v-model="value" :options="[{value: 'x', label: 'Option X'}, {value: 'y', label: 'Option Y'}, {value: 'z', label: 'Option Z'}]" />
```
</docs>
